/**
 * Utility functions for ExperimentDetailsDialog
 */

/**
 * Get status chip styling using theme colors
 * @param {string} status - Experiment status
 * @param {Object} theme - MUI theme object
 * @returns {Object} Status chip style object
 */
export const getStatusChipStyle = (status, theme) => {
  const statusStyles = {
    draft: {
      backgroundColor: theme.palette.grey?.[100] || '#F5F5F5', // Light grey background
      color: theme.palette.grey?.[700] || '#616161', // Dark grey text
      border: `1px solid ${theme.palette.grey?.[300] || '#E0E0E0'}`, // Grey border
    },
    active: {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.dark,
      border: `1px solid ${theme.palette.success.main}`,
    },
    paused: {
      backgroundColor: theme.palette.warning.light,
      color: theme.palette.warning.dark,
      border: `1px solid ${theme.palette.warning.main}`,
    },
    completed: {
      backgroundColor: theme.palette.info.light,
      color: theme.palette.info.dark,
      border: `1px solid ${theme.palette.info.main}`,
    },
    cancelled: {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.dark,
      border: `1px solid ${theme.palette.error.main}`,
    },
  };
  return statusStyles[status] || statusStyles.draft;
};

/**
 * Format traffic allocation for display
 * @param {string} allocation - Traffic allocation value
 * @returns {string} Formatted traffic allocation
 */
export const formatTrafficAllocation = allocation => {
  if (!allocation) return 'Not specified';
  const formatted = allocation
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  return formatted;
};
